import { Card, Heading, Link } from '@msaf/core-react'
import { CouncilContact } from '../../../constants/contact-us'

export default function ContactCard({ councilName, link, additionalResources, image }: CouncilContact) {
  return (
    <Card hasTabbedContent key={councilName} className='c-contact-card'>
      <div className='c-contact-card__content'>
        <div className='c-contact-card__text'>
          <Heading level={2}>{councilName}</Heading>
          <Link rel='noreferrer' target='_blank' path={link} isExternal>
            Contact us
          </Link>
          {Array.isArray(additionalResources) && additionalResources.length > 0 && (
            <>
              <h3 className='c-contact-card__subheading'>Additional resources</h3>
              {additionalResources.map((resource) => {
                return (
                  <div key={resource?.label}>
                    <Link target='_blank' rel='noreferrer' key={resource?.label} path={resource?.link ?? ''} isExternal>
                      {resource?.label}
                    </Link>
                    <br />
                  </div>
                )
              })}
            </>
          )}
        </div>
        {image && (
          <a href={image.linkPath} target='_blank' rel='noreferrer' className='c-contact-card__logo-link'>
            <img src={image.src} className='c-contact-card__logo' alt={councilName} />
          </a>
        )}
      </div>
    </Card>
  )
}
